export default "__VITE_ASSET__1c3dbaa5__"